import React from 'react'
import { FF_GROUP_WIKI_PAGES } from 'constants/featureFlags'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useFeatureFlag from 'hooks/useFeatureFlag'
import HeaderWithBackButton from 'redesign/components/organisms/headers/header-with-back-button'
import Page from 'redesign/components/templates/Page'
import ContentWikiPages from 'redesign/components/templates/wiki-pages-template/content-wiki-pages'
import ContentWikiPagesWithFolders from 'redesign/components/templates/wiki-pages-template/content-wiki-pages-with-folders'
import type { OwnerIdPageProps } from 'redesign/shared/types'

const WikiPages: React.FC<OwnerIdPageProps> = ({ match }) => {
  const { t } = useFavurTranslation()
  const groupWikiPagesFF = Boolean(useFeatureFlag(FF_GROUP_WIKI_PAGES))
  const {
    params: { ownerId },
  } = match
  const owner = parseInt(ownerId)

  return (
    <Page header={<HeaderWithBackButton title={t('page.cms.content.header')} />}>
      {groupWikiPagesFF ? <ContentWikiPagesWithFolders ownerId={owner} /> : <ContentWikiPages ownerId={owner} />}
    </Page>
  )
}

export default WikiPages
